import { Button, Card, Col, Empty, Row, Skeleton, Space, Typography } from "antd";

import { FC, useContext } from "react";
import { Owner } from "./Owner/web";
import { OwnerLogo } from "../OwnerLogo/web";
import { Subsidiary } from "./Subsidiary/web";
import { useSendTextLead } from "../../../GlobalHooks/useSendLead";
import { useTheme } from "../../../Styles/ThemeHook";
import { isProject } from "@Utils/Functions";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { Listing, Owner as OwnerI, Seller } from "shared-components";
import { getInmoLink } from "src/utils/Functions";

const { Text } = Typography;

interface SubsidiariesProps {
	id: string;
	mode: string;
	owner?: OwnerI;
	loading: boolean;
	disabled?: boolean;
	seller?: Seller;
	listing?: Listing;
}

export const Subsidiaries: FC<SubsidiariesProps> = ({
	id,
	mode,
	owner = null,
	loading,
	disabled = false,
	seller = null,
	listing = null,
}) => {
	const { country_code } = useContext(ConfigStateContext);
	const inmoLink = country_code === "CO" && !owner?.particular ? getInmoLink(owner?.id, owner?.name) : owner?.inmoLink;

	const handleClickShowNotification = async ({
		type = 'success',
		message = '',
		description = '',
	}) => {
		const { showNotification } = await import("shared-components/Components/CustomNotification/web");
		showNotification(
			type,
			message,
			description
		);
	}
	const { theme } = useTheme();

	const { sendLead, loading: loadingSendLead } = useSendTextLead({
		property_id: id,
		entity_type: mode == "auto" || mode == "project" ? "PROJECT" : "PROPERTY",
		financing_information: false,
		isAutoGenerated: false,
		source: 14,
		message: "Me gustaria obtener mas información del vendedor.",
	});

	if (loading)
		return (
			<Space direction={"vertical"} style={{ width: "100%" }}>
				{[...Array(2)].map((o, i) => (
					<Card size={"small"} key={"subsidiary_skeleton+" + i}>
						<Space style={{ width: "100%", justifyContent: "space-between" }}>
							<Skeleton
								title={false}
								paragraph={{ width: 200, rows: 3, style: { margin: 0 } }}
							/>
							<Skeleton.Button />
						</Space>
					</Card>
				))}
			</Space>
		);

	if (!owner)
		return (
			<Row justify={"center"}>
				<Empty
					imageStyle={{
						height: 50,
						opacity: 0.9,
					}}
					description={
						<Text style={{ color: theme.colors.textInverseColor }}>
							{"No hay información del vendedor, consultar información."}
						</Text>
					}>
					<Button
						loading={loadingSendLead}
						onClick={() =>
							sendLead().then(response => {
								handleClickShowNotification({
									message: response.success
										? "Consulta enviada"
										: "Error al enviar la consulta",
									type: response.success ? "success" : "error",
								});
							})
						}
						ghost>
						{"Consultar"}
					</Button>
				</Empty>
			</Row>
		);

	if (owner.subsidiaries?.length > 0) {
		return (
			<Row gutter={[0, 16]} className="subsidiaries">
				<Col span={24}>
					<OwnerLogo
						inmoLink={inmoLink}
						inmoPropsLink={owner.inmoPropsLink}
						logo={owner.logo}
						name={owner.name}
						type={"full"}
						inmoFull={owner.inmofull}
					/>
				</Col>

				{seller && seller.name ? (
					<Col span={24}>
						<Subsidiary
							id={"0"}
							name={seller.name}
							address=""
							officeHours=""
						/>
					</Col>
				) : null}

				{owner.subsidiaries.map(subsidiary => {
					if (subsidiary.address || subsidiary.office_hours) return (
						<Col span={24} key={"subsidiary_" + subsidiary.id}>
							<Subsidiary
								id={subsidiary.id}
								address={subsidiary.address}
								officeHours={subsidiary.office_hours}
								name={subsidiary.name}
							/>
						</Col>
					) 
					else return null
				})}
			</Row>
		);
	}

	return (
		<Owner
			mode={mode}
			property_id={id}
			name={owner.name}
			owner={owner}
			maskedPhone={owner.masked_phone}
			logo={owner.logo}
			disabled={disabled}
			isProject={listing.isProject}
		/>
	);
};
